import { Route, Routes } from 'react-router';
import { LeadForm } from '../leads/LeadForm.js';
import { LeadSheet } from '../leads/LeadSheet.js';
import { AddContactToLead, CreateLeadFromContact, LinkToLead } from '../leads/Pickers.js';
import { CompleteLeadWindow } from '../leads/TodoScreen.js';
import { ContactSheet } from './ContactSheet.js';
import { PeopleList } from './PeopleList.js';
import { QualifyByVoice } from '../voice/QualifyByVoice.js';

/**
 * People (brief sections 6.5 to 6.8), mounted at /people/*: the Contacts
 * and Leads tabs, and each contact's and lead's sheet, form and choices as
 * windows over the list, each with its own address so Back closes it first.
 */
export function PeopleScreen() {
  return (
    <Routes>
      {/* One list per tab (key): a search typed in one never rewrites the address of the other. */}
      <Route element={<PeopleList key="contacts" tab="contacts" />}>
        <Route index element={null} />
        <Route path="contacts/:id" element={<ContactSheet mode="view" />} />
        <Route path="contacts/:id/edit" element={<ContactSheet mode="edit" />} />
        <Route path="contacts/:id/verify" element={<ContactSheet mode="verify" />} />
        <Route path="contacts/:id/lead" element={<CreateLeadFromContact />} />
        <Route path="contacts/:id/project" element={<CreateLeadFromContact ask />} />
        <Route path="contacts/:id/voice" element={<QualifyByVoice />} />
        <Route path="contacts/:id/link-lead" element={<LinkToLead />} />
      </Route>
      <Route path="leads" element={<PeopleList key="leads" tab="leads" />}>
        <Route index element={null} />
        <Route path=":id" element={<LeadSheet />} />
        <Route path=":id/edit" element={<LeadForm />} />
        <Route path=":id/add-contact" element={<AddContactToLead />} />
        <Route path=":id/complete" element={<CompleteLeadWindow />} />
      </Route>
    </Routes>
  );
}
